import logo from "@/assets/images/logo.png";
import headerLogo from "@/assets/images/header-logo.png";
import vanHero from "@/assets/images/van-hero.png";
// Brand logos
import airtouch5 from "@/assets/images/airtouch5.png";
import fujitsu from "@/assets/images/fujitsu.png";
import mitsubishi from "@/assets/images/mitsubishi.png";
import daikin from "@/assets/images/daikin.png";
import brivis from "@/assets/images/brivis.png";
import toshiba from "@/assets/images/toshiba.png";
import braemar from "@/assets/images/braemar.png";
// Real project photos
import photoMitsubishiOutdoor from "@/assets/images/work2.png";
import photoKitchenDucted from "@/assets/images/work3.png";
import photoInteriorDucted from "@/assets/images/work4.png";
import photoCommissioning from "@/assets/images/commissioning.jpeg";
import photoReclaim from "@/assets/images/reclaim-heatpump.jpeg";
// Heat pump assets
import hpInstalled from "@/assets/images/hp-installed.png";
import hpBeforeAfter from "@/assets/images/hp-before-after.jpeg";
import hpEmerald from "@/assets/images/hp-emerald.png";
import hpNeoPower from "@/assets/images/hp-neopower.png";
import hpMidea from "@/assets/images/hp-midea.png";
import veuBadge from "@/assets/images/veu-badge.png";
// AirTouch smart control graphics
import airtouchHome from "@/assets/images/airtouch-home.png";
import airtouchPanel from "@/assets/images/airtouch-graphic.png";

export const ASSETS = {
  logo, headerLogo, vanHero, veuBadge, airtouchHome, airtouchPanel,
  hpBeforeAfter, hpInstalled, photoReclaim,
};

export const BRAND_LOGOS = [
  { name: "Daikin", logo: daikin },
  { name: "Mitsubishi Heavy Industries", logo: mitsubishi },
  { name: "Fujitsu", logo: fujitsu },
  { name: "Toshiba", logo: toshiba },
  { name: "Braemar", logo: braemar },
  { name: "Brivis", logo: brivis },
  { name: "AirTouch", logo: airtouch5 },
  { name: "ActronAir", logo: null },
];

export const BUSINESS = {
  name: "Access Electrical and Air Conditioning Services Pty Ltd",
  shortName: "Access Electrical & Air Conditioning",
  abn: "38 621 198 294",
  email: "info@accesselectricalandairconditioning.com.au",
  phone: "+61 481 346 826",
  phoneHref: "tel:+61481346826",
  emailHref: "mailto:info@accesselectricalandairconditioning.com.au",
  yearsInBusiness: "9",
  combinedExperience: "25+",
  owner: "Danrell",
  offices: [
    { label: "Head Office", address: "Suite 535/1 Queens Rd, Melbourne VIC 3004, Australia" },
    { label: "Office 2", address: "99 View St, Bendigo VIC 3550, Australia" },
    { label: "Office 3", address: "562 Pennant Hills Rd, West Pennant Hills NSW 2125, Australia" },
  ],
  credentials: [
    "CEC Certified",
    "Licensed Installers",
    "Service Victoria-Wide",
    "Professional heating, cooling & electrical team",
  ],
};

export const NAV = [
  { label: "Home", to: "/", testId: "nav-home" },
  { label: "About Us", to: "/about", testId: "nav-about" },
  { label: "Services", to: "/services", testId: "nav-services" },
  { label: "Areas We Serve", to: "/areas-we-serve", testId: "nav-areas" },
  { label: "Gallery", to: "/gallery", testId: "nav-gallery" },
  { label: "Contact", to: "/contact", testId: "nav-contact" },
];

// Stock fallback (electrician photo — no real electrical photo supplied)
const STOCK_ELECTRICAL = "https://images.unsplash.com/photo-1660330589827-da8ab7dd3c02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
const STOCK_TECH = "https://images.unsplash.com/photo-1701058666995-07adcef94170?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const IMG = {
  mitsubishiOutdoor: photoMitsubishiOutdoor,
  kitchenDucted: photoKitchenDucted,
  interiorDucted: photoInteriorDucted,
  commissioning: photoCommissioning,
  reclaim: photoReclaim,
  hpInstalled,
  hpBeforeAfter,
  electrical: STOCK_ELECTRICAL,
  tech: STOCK_TECH,
};

export const SERVICES = [
  {
    slug: "split-system-air-conditioning",
    title: "Split System Air Conditioning",
    short: "Efficient, quiet cooling and heating for single rooms and living spaces.",
    icon: "Wind",
    image: photoMitsubishiOutdoor,
  },
  {
    slug: "ducted-reverse-cycle-air-conditioning",
    title: "Ducted Reverse Cycle Air Conditioning",
    short: "Whole-home climate control that heats and cools every room, discreetly.",
    icon: "Snowflake",
    image: photoKitchenDucted,
  },
  {
    slug: "multi-split-air-conditioning",
    title: "Multi-Split Air Conditioning",
    short: "Multiple indoor units powered by one outdoor unit — ideal for zoning.",
    icon: "LayoutGrid",
    image: photoCommissioning,
  },
  {
    slug: "ducted-heating-and-cooling",
    title: "Ducted Heating & Cooling",
    short: "Consistent, energy-smart comfort throughout the entire property.",
    icon: "Thermometer",
    image: photoInteriorDucted,
  },
  {
    slug: "heat-pump-hot-water",
    title: "Heat Pump Hot Water Systems",
    short: "Energy-efficient hot water that draws heat from the surrounding air.",
    icon: "Droplets",
    image: hpInstalled,
  },
  {
    slug: "electrical-services",
    title: "Electrical Services",
    short: "Safe, professional residential electrical work by qualified trades.",
    icon: "Zap",
    image: STOCK_ELECTRICAL,
  },
];

export const SERVICE_DETAILS = {
  "split-system-air-conditioning": {
    title: "Split System Air Conditioning",
    tagline: "Cooling & Heating",
    hero: photoMitsubishiOutdoor,
    intro:
      "A split system is one of the most popular and cost-effective ways to heat and cool a home. It pairs a slim indoor unit with an outdoor compressor, delivering quiet, efficient reverse-cycle comfort to a single room or open living area.",
    what:
      "Split system air conditioning uses two connected units — an indoor head mounted on the wall and an outdoor compressor. Refrigerant moves between them to cool your space in summer and warm it in winter, all from a single, quiet system.",
    suits: [
      "Bedrooms, living rooms and home offices",
      "Homes wanting room-by-room control",
      "Apartments and smaller properties",
      "Anyone after an affordable, quick installation",
    ],
    benefits: [
      "Reverse-cycle heating and cooling in one unit",
      "Quiet, energy-efficient operation",
      "Precise temperature and timer control",
      "Compact, unobtrusive indoor design",
    ],
    images: [photoMitsubishiOutdoor, photoCommissioning],
  },
  "ducted-reverse-cycle-air-conditioning": {
    title: "Ducted Reverse Cycle Air Conditioning",
    tagline: "Whole-Home Comfort",
    hero: photoKitchenDucted,
    intro:
      "Ducted reverse cycle air conditioning delivers discreet, whole-home heating and cooling from a single system. Ducts hidden in the ceiling or roof space feed air to each room through slimline outlets, keeping your interiors clean and uncluttered.",
    what:
      "A central unit connects to a network of ducts running through your roof space. Conditioned air is distributed to every room through ceiling vents, with zoning options that let you control temperatures in different areas independently.",
    suits: [
      "New builds and full-home renovations",
      "Homes wanting a seamless, hidden system",
      "Larger properties with multiple rooms",
      "Owners who value consistent comfort",
    ],
    benefits: [
      "One system heats and cools the whole home",
      "Discreet — only the outlets are visible",
      "Zoning for room-by-room efficiency",
      "Quiet, even temperature distribution",
    ],
    images: [photoKitchenDucted, photoInteriorDucted],
    showAirTouch: true,
  },
  "multi-split-air-conditioning": {
    title: "Multi-Split Air Conditioning",
    tagline: "Flexible Zoning",
    hero: photoCommissioning,
    intro:
      "A multi-split system connects several indoor units to a single outdoor compressor — perfect when you want to condition multiple rooms without the space or expense of separate outdoor units for each.",
    what:
      "One outdoor unit powers up to several indoor heads, each independently controlled. It's an ideal middle ground between individual split systems and a fully ducted setup, giving you flexible zoning with a tidy exterior.",
    suits: [
      "Homes with limited outdoor space",
      "Multi-room cooling without full ducting",
      "Apartments and townhouses",
      "Properties wanting independent room control",
    ],
    benefits: [
      "One outdoor unit serves multiple rooms",
      "Independent control for each indoor head",
      "Saves outdoor space and wall clutter",
      "Energy-efficient zoned comfort",
    ],
    images: [photoCommissioning, photoMitsubishiOutdoor],
  },
  "ducted-heating-and-cooling": {
    title: "Ducted Heating & Cooling",
    tagline: "Year-Round Climate",
    hero: photoInteriorDucted,
    intro:
      "Ducted heating and cooling keeps your entire home at the perfect temperature all year round. With smart zoning and modern controls, you get even, efficient comfort in every room from one central system.",
    what:
      "A ducted heating and cooling system distributes conditioned air throughout your home via ceiling or floor outlets. Modern zoning and smart controllers let you heat or cool only the spaces you're using, reducing energy waste.",
    suits: [
      "Family homes wanting total comfort",
      "Properties across multiple living zones",
      "Owners upgrading older heating systems",
      "Anyone wanting smart, efficient control",
    ],
    benefits: [
      "Whole-home heating and cooling",
      "Smart zoning to cut running costs",
      "Even, draught-free temperatures",
      "Compatible with smart control systems",
    ],
    images: [photoInteriorDucted, photoKitchenDucted],
    showAirTouch: true,
  },
  "electrical-services": {
    title: "Electrical Services",
    tagline: "Safe & Professional",
    hero: STOCK_ELECTRICAL,
    intro:
      "From general electrical installation to the wiring behind your air conditioning, our team delivers safe, compliant and professional electrical workmanship — with access to a qualified A-Grade Electrician for every job.",
    what:
      "We handle the electrical work that keeps your home safe and your systems running. That includes the dedicated circuits and switchboard work often required when installing air conditioning, as well as general residential electrical installation.",
    suits: [
      "Homes installing new air conditioning",
      "Properties needing switchboard assessment",
      "General residential electrical work",
      "Owners wanting compliant, safe workmanship",
    ],
    benefits: [
      "Residential electrical services",
      "Electrical work for air-conditioning installs",
      "Switchboard assessment & upgrades where required",
      "Dedicated circuits & general installation",
    ],
    images: [STOCK_ELECTRICAL, STOCK_TECH],
    services: [
      "Residential electrical services",
      "Electrical work associated with air-conditioning installation",
      "Switchboard assessment and upgrades where required",
      "Dedicated circuits",
      "General electrical installation",
      "Safe, professional workmanship",
    ],
  },
};

export const INSTALL_STEPS = [
  { n: "01", title: "Site Assessment", desc: "We visit your property to understand your space, needs and existing setup." },
  { n: "02", title: "System Recommendation", desc: "We recommend the right system and provide a clear, upfront quote." },
  { n: "03", title: "Professional Installation", desc: "Our qualified team installs your system with care and precision." },
  { n: "04", title: "Testing & Handover", desc: "We test everything and walk you through how to use your new system." },
];

export const HEAT_PUMP_BENEFITS = [
  { icon: "Leaf", title: "Energy Efficient", desc: "Draws free heat from the air, using far less energy than electric resistance systems." },
  { icon: "PiggyBank", title: "Lower Running Cost Potential", desc: "Reduced energy use can mean lower ongoing hot water bills over time." },
  { icon: "Plug", title: "Reduced Electricity Use", desc: "Uses a fraction of the electricity of conventional electric storage systems." },
  { icon: "CloudSun", title: "Lower Carbon Emissions", desc: "A cleaner alternative to gas and traditional electric hot water." },
  { icon: "Cpu", title: "Modern Technology", desc: "Smart controls and scheduling for reliable, efficient hot water." },
  { icon: "CalendarCheck", title: "Reliable Year-Round", desc: "Engineered to deliver consistent hot water across the seasons." },
  { icon: "BadgeDollarSign", title: "Potential Incentives", desc: "Eligible customers may access government-supported incentives." },
];

export const HEAT_PUMP_SYSTEMS = [
  { name: "Emerald Energy", capacity: "Up to 320 L", note: "High-efficiency option for larger households wanting top-tier performance.", image: hpEmerald },
  { name: "NeoPower", capacity: "Up to 315 L", note: "Reliable, efficient water heating well suited to mid-sized homes.", image: hpNeoPower },
  { name: "Midea", capacity: "Up to 280 L", note: "Smart, feature-rich system ideal for smaller to mid households.", image: hpMidea },
];

export const HEAT_PUMP_FAQS = [
  { q: "What is a heat pump hot water system?", a: "It's a hot water system that uses electricity to move heat from the surrounding air into your water tank, rather than generating heat directly. This makes it far more efficient than a conventional electric element system." },
  { q: "How much more efficient is a heat pump?", a: "Because it moves heat rather than creating it, a heat pump can use a fraction of the electricity of a traditional electric storage system to heat the same amount of water." },
  { q: "Can it replace my existing hot water system?", a: "Yes. Heat pump systems can replace old electric storage units, gas hot-water systems, and inefficient older systems. We assess your property and recommend the right replacement." },
  { q: "Does it work in cold weather?", a: "Modern heat pump systems are designed to operate reliably across a wide range of temperatures, delivering consistent hot water year-round." },
  { q: "Is it noisy?", a: "Heat pump units run quietly. We assess placement during your site visit to minimise any noise near living or sleeping areas." },
  { q: "Am I eligible for a government incentive?", a: "Eligible Victorian customers may be able to access government-supported incentives depending on current program rules, property eligibility, and the system being replaced. We can talk you through what may apply." },
  { q: "How long does installation take?", a: "Most straightforward replacements are completed within a day. We confirm the timeline after your site assessment." },
  { q: "What maintenance is required?", a: "Heat pump systems are low maintenance with fewer components than combustion-based systems. We recommend periodic checks to keep them running efficiently." },
  { q: "Which brands do you install?", a: "We work with trusted heat pump brands including Emerald Energy, NeoPower and Midea, and recommend the best fit for your household size and needs." },
  { q: "How do I get started?", a: "Request a free quote and we'll arrange a site assessment, recommend a suitable system, and handle a professional installation." },
];

export const AREAS = {
  vic: [
    "Bendigo",
    "Rural Bendigo area",
    "Ballarat and surrounding areas",
    "Hamilton",
    "Geelong",
    "Warrnambool",
    "West Melbourne and surrounding areas",
  ],
  nsw: ["West Pennant Hills", "Pennant Hills", "Hornsby and surrounding areas"],
};

export const GALLERY = [
  { src: photoMitsubishiOutdoor, alt: "Mitsubishi Heavy Industries outdoor units installed on a coastal home" },
  { src: photoKitchenDucted, alt: "Ducted air conditioning ceiling outlet above a modern kitchen" },
  { src: photoCommissioning, alt: "Multiple outdoor air conditioning units during commissioning" },
  { src: hpInstalled, alt: "Heat pump hot water system installed against a brick wall" },
  { src: photoReclaim, alt: "Heat pump hot water installation" },
  { src: photoInteriorDucted, alt: "Discreet ducted outlet in a modern living interior" },
  { src: hpBeforeAfter, alt: "Gas hot water system replaced with an energy-efficient heat pump" },
];

export const SERVICE_OPTIONS = [
  "Split System Air Conditioning",
  "Ducted Air Conditioning",
  "Multi-Split Air Conditioning",
  "Heat Pump Hot Water",
  "Electrical Services",
  "Other",
];

export const HOME_TESTIMONIALS = [
  {
    name: "Maria C.",
    rating: 5,
    google: true,
    quote:
      "Access installed our ducted system and handled the whole job professionally from the first quote through to handover. Tidy, reliable and genuinely easy to deal with — highly recommend.",
  },
  {
    name: "Natalie H.",
    rating: 5,
    google: true,
    quote:
      "The team fitted our split systems and were prompt, friendly and knew exactly what we needed. Really happy with the workmanship and the finished result.",
  },
  {
    name: "Laurence H.",
    rating: 5,
    google: true,
    quote:
      "Excellent service on our air conditioning installation. Arrival was on time, the work was clean, and everything was explained clearly. Great value and a quality install.",
  },
  {
    name: "Rex H.",
    rating: 5,
    google: true,
    quote:
      "Access replaced our old hot water unit with an energy-efficient heat pump. The job was efficient, smooth and quick, and the team were friendly throughout. Couldn't be happier.",
  },
];

export const PROCESS_STEPS = [
  { n: "01", icon: "ClipboardList", title: "Quick Property Assessment", desc: "We discuss your requirements and assess the property, existing equipment and the type of electrical, air conditioning or hot water solution you need." },
  { n: "02", icon: "FileText", title: "Clear Recommendation & Quote", desc: "We recommend a suitable solution and provide a clear quotation so you understand the proposed work before installation begins." },
  { n: "03", icon: "Wrench", title: "Professional Installation", desc: "Our qualified trade team completes the installation carefully, with attention to workmanship, compliance and the requirements of your property." },
  { n: "04", icon: "Gauge", title: "System Testing & Setup", desc: "We test and commission the equipment, check operation and make sure the new system is functioning correctly." },
  { n: "05", icon: "UserCheck", title: "Customer Handover", desc: "Before finishing, we explain the basic controls and operation of your new system and answer any questions you may have." },
];

export const HOME_FAQS = [
  { q: "What air conditioning system is right for my home?", a: "The best system depends on the size and layout of the property, how many areas you want to condition, your usage requirements and the available installation space. We can assess the property and recommend an appropriate option." },
  { q: "What is the difference between split, multi-split and ducted air conditioning?", a: "A split system generally conditions an individual room or area. Multi-split systems connect multiple indoor units to an outdoor system, while ducted air conditioning distributes conditioned air throughout multiple rooms using concealed ductwork." },
  { q: "How long does air conditioning installation take?", a: "Installation time varies depending on the type of system, property access and the electrical or building requirements involved. Straightforward installations may be completed relatively quickly, while larger ducted or multi-system projects require additional time." },
  { q: "Can you replace my existing air conditioner?", a: "Yes. We can assess an existing system and discuss suitable replacement options based on the property, existing infrastructure and current heating and cooling requirements." },
  { q: "Can I replace my old gas or electric hot water system with a heat pump?", a: "In many properties, a modern heat pump hot water system can replace an older gas or electric hot water unit. The installation requirements depend on the existing system, available space, plumbing, electrical supply and site conditions." },
  { q: "Are heat pump rebates or incentives available?", a: "Eligible Victorian customers may be able to access government-supported energy-efficiency incentives under applicable programs. Eligibility depends on current program rules, the property, the existing equipment and installation requirements. Contact our team for an assessment." },
  { q: "Do you provide both electrical and air conditioning work?", a: "Yes. Access Electrical and Air Conditioning provides electrical, heating and cooling services, with access to the appropriate qualified trades required for the installation being completed." },
];
